export default __webpack_public_path__ + "static/media/LENS_CULINARIS_DEFAULT_complete_4.05e9d58c.jpg";